import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import * as S from './PlaylistItem.styles';
import * as T from './PlaylistItem.types';
import * as SL from 'modules/Player/selectors';
import { PLAYING } from 'modules/Player/constants';
import * as A from 'modules/Player/actions';
import Spinner from 'components/Spinner/Spinner';
import { IRootState } from '../../reducer.types';

export class PlaylistItem extends PureComponent<T.IPlaylistItemProps, T.IPlaylistItemState> {
  defaultState: T.IPlaylistItemState = {
    isHovered: false,
  };

  state = {
    isHovered: false,
  };

  hoverTimeout: any = 0;

  resetInternalState = () =>
    this.setState((prevState) => {
      if (prevState.isHovered) {
        return { ...this.defaultState };
      }
    });

  onMouseEnter = () => {
    clearTimeout(this.hoverTimeout);

    this.hoverTimeout = setTimeout(() => {
      this.setState(() => {
        return { isHovered: true };
      });
    }, 2000);
  };

  onMouseLeave = () => {
    clearTimeout(this.hoverTimeout);

    this.hoverTimeout = setTimeout(this.resetInternalState, 100);
  };

  onTrackInit = () => {
    const {
      dispatchSetPlayStatus,
      dispatchSetCurrentlyPlayingTrackId,
      currentlyPlayingTrackId,
      id,
    } = this.props;

    this.onMouseLeave();

    if (id === currentlyPlayingTrackId) {
      return;
    }

    if (dispatchSetCurrentlyPlayingTrackId) {
      dispatchSetCurrentlyPlayingTrackId({ id });
    }

    if (dispatchSetPlayStatus) {
      dispatchSetPlayStatus({ playStatus: PLAYING });
    }
  };

  render() {
    const { isHovered } = this.state;
    const { playlistPosition, track, isCurrentlyPlaying, isTrackApiRequestPending } = this.props;
    const headline = track ? track.headline : '';
    const isLoading = isCurrentlyPlaying && isTrackApiRequestPending;

    return (
      <S.PlaylistItem
        className={`noselect ${isCurrentlyPlaying ? 'isCurrentlyPlaying' : ''}`}
        data-testid={`PlaylistItem-${playlistPosition}`}
        onClick={this.onTrackInit}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
      >
        <S.PlaylistItemWrapper>
          {isLoading ? (
            <S.PlaylistItemSpinnerWrapper playlistPosition={playlistPosition}>
              <Spinner width={13} height={13} />
            </S.PlaylistItemSpinnerWrapper>
          ) : (
            <S.PlaylistItemPosition
              playlistPosition={playlistPosition}
            >{`${playlistPosition}.`}</S.PlaylistItemPosition>
          )}

          <S.PlaylistItemText isLoading={isLoading} playlistPosition={playlistPosition}>
            {headline}
          </S.PlaylistItemText>
        </S.PlaylistItemWrapper>

        {isHovered ? (
          <S.PlayOverviewTooltip
            onMouseEnter={this.onMouseEnter}
            onMouseLeave={this.onMouseLeave}
            onClick={this.onMouseLeave}
          >
            {headline}
          </S.PlayOverviewTooltip>
        ) : null}
      </S.PlaylistItem>
    );
  }
}

const mapStateToProps = (state: IRootState, ownProps: T.IPlaylistItemProps) => ({
  track: SL.getTrack(state, ownProps.id),
  isTrackApiRequestPending: SL.getIsTrackApiRequestPending(state),
  currentlyPlayingTrackId: SL.getCurrentlyPlayingTrackId(state),
});

const mapDispatchToProps = {
  dispatchSetPlayStatus: A.setPlayStatus,
  dispatchSetCurrentlyPlayingTrackId: A.setCurrentlyPlayingTrackId,
};

export default connect(mapStateToProps, mapDispatchToProps)(PlaylistItem);
